// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Email-based Auth Guard for /admin.
// If the currently logged-in Google user matches ADMIN_EMAIL, forward to /admin/dashboard.
// Otherwise, redirect to home. This page has no visible form — access is silent.
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("/admin/check");
        if (res.data.ok) {
          navigate("/admin/dashboard", { replace: true });
          return;
        }
      } catch {
        // fall through
      }
      navigate("/", { replace: true });
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505]">
      <div className="text-[#00F0FF] font-mono-arcade text-xs uppercase tracking-[0.3em] animate-pulse">
        Verifying access...
      </div>
    </div>
  );
}
